import * as React from "react"
import { Container, Box, Text, Section, Flex, Heading, SubheadSmall, Card, Header, Button, Subhead, FlexList } from "../../ui"
import { StaticImage } from "gatsby-plugin-image"
import { BiChevronRight } from "react-icons/bi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { black_color, gardient_btns,marginLeft } from "../../ui.css";
export default function Infrastructure(props) {
    return (
        <>
            <Section></Section>
            <Section className={black_color}>
                <Container width="narrow2">
                    <Flex gap={4} variant="responsive" >
                        <Box >
                            <StaticImage src='../../../images/college_images/college_img3.png' alt="college_img3" />
                        </Box>
                        <Card className={marginLeft}>
                            <Box>
                                <Subhead> Infrastructure  <StaticImage src="../images/skill_icon.png" transformOptions={{ fit: "cover", cropFocus: "attention" }} alt="skill_icon" width={20} style={{ marginTop: "2%" }} /></Subhead>
                                <FlexList>
                                    <li>
                                        <Text><IoIosCheckmarkCircle /></Text>
                                    </li>
                                    <li>
                                        <Text>One Big hall to be named as 'Business Laboratory'.  </Text>
                                    </li>
                                </FlexList>
                                <FlexList>
                                    <li>
                                        <Text><IoIosCheckmarkCircle /></Text>
                                    </li>
                                    <li>
                                        <Text> Team installs the busienss laboratory (BizzLab Software) and give training to the students</Text>
                                    </li>
                                </FlexList>
                                <FlexList>
                                    <li>
                                        <Text><IoIosCheckmarkCircle /></Text>
                                    </li>
                                    <li>
                                        <Text>Min 10 computers </Text>
                                    </li>
                                </FlexList>



                                <Button className={gardient_btns}>Start Now <BiChevronRight /></Button>
                            </Box>
                        </Card>
                    </Flex>
                </Container>
            </Section>
            <Section></Section>
        </>
    )
}
